module.exports = __webpack_public_path__ + "img/linkedin-logo.60806e36.png";